<template>
  <v-wait for="gonderi-inserting">
    <template slot="waiting">
      <div class="vue-wait-class">
        <img src="static/loading.svg" />
        <p>Kayıt yapılıyor...</p>
      </div>
    </template>
    <div class="container mb-4">
      <div class="py-3 text-center">
        <h2>Toplu Ürün Çıkış Formu</h2>
        <p class="lead">Çıkışı yapılan ürünlerin bilgilerini aşağıdaki forma işleyiniz.</p>
      </div>
      <div class="row mb-4">
        <div class="col-md-12 order-md-1">
          <div class="row mb-3">
            <div class="col-md-3 mb-3">
              <label for="firstName">Çıkış Tarihi</label>
              <datepicker :bootstrap-styling="true" v-model="urunCikisKaydi.OUT_DATE" :format="dateFormatter"></datepicker>
              <!--<input type="text" class="form-control date-input" id="firstName" placeholder="" value="" required>-->
              <div class="invalid-feedback">
                Valid first name is required.
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <label for="out-retailer">Bayii Adı</label>
              <select class="custom-select" id="out-retailer" v-model="urunCikisKaydi.OUT_RETAILER">
                <option value="0" selected>Bayii seçiniz...</option>
                <option v-for="(retailer, retailerIndex) in retailers"
                  v-bind:key="'retailer-'+ retailerIndex"
                  :value="retailer.RETAILER_ID.toString()">
                  {{retailer.RETAILER_NAME}}</option>
                <option value="100" selected>Stok Dışı Cihazlar</option>
                <option value="101" selected>ARIZA</option>
              </select>
              <div class="invalid-feedback">
                Valid last name is required.
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <label for="out-customer">Müşteri Adı</label>
              <cool-select v-model="selectedCustomer" id="out-customer" :items="foundCustomers" :loading="customerSearching"
                disable-filtering-by-search  @select="onCustomerSelect"
                @search="onCustomerSearch" item-text="CUSTOMER_TITLE" placeholder="Müşteri...">
                <template slot="no-data">Müşteri bulunamadı</template>
                <div slot="item" class="search-slot-item" slot-scope="{ item }">
                  <p class="text-truncate">{{item.CUSTOMER_TITLE}}</p>
                  <small class="text-primary" >Müşteri Kodu : {{item.CUSTOMER_ID}}</small>
                </div>
              </cool-select>
              <div class="invalid-feedback">
                Valid last name is required.
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <label for="out-contract">Sözleşme Seçimi</label>
              <select class="custom-select" id="out-contract" v-model="urunCikisKaydi.OUT_CONTRACT">
                <option value="0" selected>DEMO</option>
                <option v-for="(contract, contractIndex) in customerContracts"
                  v-bind:key="'contract-'+ contractIndex"
                  :value="contract.CONTRACT_ID">
                  {{contract.DISPLAY_NAME}}</option>
              </select>
              <div class="invalid-feedback">
                Valid last name is required.
              </div>
            </div>
          </div>
          <div class="row mb-5">
            <div class="col-md-3 mb-3">
              <label for="lastName">Çıkış Faturası / İrsaliyesi</label>
              <input type="text" class="form-control"
                v-model="urunCikisKaydi.OUT_WAYBILL_CODE" id="lastName" placeholder="Fatura No / İrsaliye No" value="" maxlength="15" required>
              <div class="invalid-feedback">
                Valid last name is required.
              </div>
            </div>
            <div class="col-md-9 mb-3">
              <label for="out-campaign">Kampanya Seçimi</label>
              <div class="form-inline">
                <div class="form-group">
                  <select class="custom-select" style="width: 300px"  id="out-campaign" v-model="urunCikisKaydi.OUT_CAMPAIGN">
                    <option value="0">Kampanyasız Satış</option>
                    <option v-for="(cmp, cmpIndex) in campaigns"
                      v-bind:key="'cmp-'+ cmpIndex"
                      :value="cmp.CAMPAIGN_ID">
                      {{cmp.CAMPAIGN_NAME}}</option>
                  </select>
                  <small id="passwordHelpInline" class="ml-3 text-muted">
                    Kampanya seçimi, özel satışlar için geçerlidir. Normal satışlar için <strong>Kampanyasız Satış</strong> seçeneğini işaretleyiniz.
                  </small>
                </div>
              </div>
            </div>
          </div>
          <h4 class="mb-3 align-middle">Çıkışı Yapılan Cihazlar
            <button class="btn btn-primary btn-more-radius btn-sm" data-toggle="modal"
              data-target="#modalSetList" aria-expanded="false">Ürün Seti Ekle</button>
            <button class="btn btn-success btn-more-radius btn-sm" @click="enterOnRow(-1)">Cihaz Ekle</button>
            <button class="btn btn-danger btn-more-radius btn-sm float-right" @click="deleteAllRows()">Tüm Cihazları Sil</button>
          </h4>
          <div class="row mb-5">
            <div class="col-md-12">
              <div class="mb-2" v-for="(data, index) in dataRows" v-bind:key="'trow-' + rowKey(data)">
                <div class="input-group">
                  <div class="input-group-prepend" style="width: 220px;">
                    <input type="text" :value="index + 1" disabled class="input-group-text form-control" style="width: 40px;"/>
                    <select v-model="dataRows[index].DeviceType" @change="onDeviceModelChange" class="custom-select input-group-text form-control" id="out-device-type">
                      <option value="0" selected>Cihaz türü...</option>
                      <option v-for="(item, index) in sarflar" v-bind:key="'item-'+index" :value="parseInt(item.MALZEME_ID)">{{item.MALZEME_NAME}}</option>
                    </select>
                  </div>
                  <input :ref="'deviceid-' + rowKey(data)" type="text" maxlength="15"
                    v-model="dataRows[index].DeviceId"
                    class="form-control"
                    :class="{'is-invalid' : dataRows[index].DeviceId.length < 15}"
                    @input="onSerialInput(data)"
                    @blur="lookupPairedGsm(data)"
                    @keydown.tab="lookupPairedGsm(data, true)"
                    @keydown.enter.prevent="onSerialEnter(data)"
                    placeholder="Cihaz Seri No"
                    aria-label="Amount (to the nearest dollar)">
                  <div class="input-group-append" style="min-width: 220px !important;">
                    <gsm-autocomplete v-if="!isNonAtsDevice(data.DeviceType)" :ref="'gsm-' + rowKey(data)"
                      v-model="dataRows[index].GsmNo" placeholder="Hat numarası..."
                      :usage="rowState(data).usage" :warning="!!rowState(data).usage || rowState(data).conflict"
                      :verified="rowState(data).status === 'free' || rowState(data).status === 'same'"
                      :unregistered="rowState(data).status === 'unregistered'"
                      @select="onGsmSelect(data, $event)" @commit="checkGsmUsage(data)" @enter="goToNextRow(data)" />
                    <template v-else>
                      <select v-model="dataRows[index].HddBrand" @change="onDeviceModelChange"
                        class="custom-select input-group-text form-control" id="out-hdd-brand">
                        <option value="Marka" selected>HDD Markası...</option>
                        <option value="Western Digital">Western Digital</option>
                        <option value="Seagate">Seagate</option>
                      </select>
                      <input :ref="'hddserial-' + rowKey(data)" v-model="dataRows[index].HddSerial" type="text" placeholder="HDD Seri Numarası"
                        @keydown.enter.prevent="goToNextRow(data)" class="input-group-text form-control">
                      <select v-model="dataRows[index].HddCapacity" @change="onDeviceModelChange" class="custom-select input-group-text form-control" id="out-hdd-cap">
                        <option value="0" selected>HDD Kapasitesi...</option>
                        <option value="1 TB">1 TB</option>
                        <option value="500 GB">500 GB</option>
                        <option value="4 TB">4 TB</option>
                      </select>
                    </template>
                    <button class="btn btn-danger" @click="deleteRow(index)" type="button">
                      <i class="fas fa-times text-white"></i>
                    </button>
                  </div>
                </div>
                <div v-if="rowState(data).conflict" class="gsm-notes">
                  <div>
                    <i class="fas fa-exclamation-triangle text-warning mr-1"></i>Sistemde eşli hat:
                    <a href="#" @click.prevent="usePairedGsm(data)">{{ pairedGsmByRow[rowKey(data)] }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-5"></div>
          <h4 class="mb-3">Çıkışı Yapılan Diğer Ürünler
            <button class="btn btn-danger btn-more-radius btn-sm float-right" @click="deleteAllOthers()">Tümünü Malzemeleri Sil</button>
          </h4>
          <div class="row mb-4">
            <div class="col-md-12">
              <cool-select v-model="selectedSarfMalzeme" item-text="MALZEME_NAME" :loading="malzemeSearching"
                disable-filtering-by-search :items="fetchedSarfMalzemeleri"
                placeholder="Sarf malzemesini arayın, bulunca seçin ve enter'a basarak çıkışa ekleyin."
                @select="onSelect" @search="onSearch" >
                <template slot="no-data">Arama kriterinize uygun malzeme bulunamadı.</template>
                <template slot="item" slot-scope="{ item }">
                  <div>
                    <p class="my-0 font-weight-bold" style="font-size: .875rem">{{item.MALZEME_NAME}} <span class="text-muted">{{item.MALZEME_CODE}}</span></p>
                    <small class="text-primary" style="font-size: .75rem">{{item.MALZEME_TYPE}}</small>
                    <small class="text-secondary" style="font-size: .75rem">{{item.MALZEME_DETAIL}}</small>
                  </div>
                </template>
              </cool-select>
              <!--<input type="text" v-model="other.MALZEME_NAME" class="form-control" @keyup.enter="enterOnRowOther()" placeholder="Malzeme adı ve ya kodu" aria-label="Amount (to the nearest dollar)">-->
            </div>
          </div>
          <div class="row mb-5">
            <div class="col-md-12">
              <div class="input-group mb-2" v-for="(other, index) in otherRows" v-bind:key="'trow-'+index">
                <input class="form-control form-control-text" disabled :value="otherRows[index].MALZEME_NAME" />
                <div class="input-group-append">
                  <input type="text" v-model="otherRows[index].MALZEME_SPENT" placeholder="Gönderilen Miktar" class="input-group-text bg-white form-control">
                  <input v-bind:id="'tcount-len' + index" disabled type="text" :value="otherRows[index].MALZEME_LENOI" placeholder="Ürün Montaj Ekibi Stoğu" class="input-group-text form-control">
                  <input v-bind:id="'tcount-ume' + index" disabled type="text" :value="otherRows[index].MALZEME_URUNMONTAJ" placeholder="Lenoi Stoğu" class="input-group-text form-control">
                  <button class="btn btn-danger" @click="deleteRowOther(index)" type="button"><i class="fas fa-times text-white"></i></button>
                </div>
              </div>
            </div>
          </div>
          <h4 class="mb-3 mt-3">Ürün Çıkış Notu</h4>
          <div class="row mb-4">
            <div class="col-md-12">
              <textarea rows="4" id="ariza-note" placeholder="Ürün Çıkış Notu"
                v-model="urunCikisKaydi.OUT_NOTE" required class="form-control" />
            </div>
          </div>
          <button class="btn btn-primary btn-lg btn-block" :disabled="gsmValidating" @click="insertUrunCikis()">
            {{ gsmValidating ? 'SIM kartlar kontrol ediliyor...' : 'Kaydı Tamamla' }}
          </button>
        </div>
      </div>
      <div class="mb-4"></div>
      <div class="modal fade bd-example-modal-lg"  id="modalSetList" tabindex="-1"
        role="dialog" aria-labelledby="modalSetListLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header bg-primary">
              <h5 class="modal-title text-white" id="trackNumberModalLabel">{{addSetPage == 0 ? 'Ürün Setini Seçin' : 'Set Miktarını Belirleyin'}}</h5>
              <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" style="padding: 0; margin: 0;">
              <v-wait for="sets-loading">
                <template slot="waiting">
                  <div class="vue-wait-class">
                    <img src="static/loading.svg" />
                    <p>Setler Yükleniyor...</p>
                  </div>
                </template>
                <div class="container-fluid no-padding">
                  <div class="row">
                    <div class="col-12 p-0 mt-1" v-if="addSetPage == 0">
                      <div class="list-group list-group-flush">
                        <div class="list-group-item d-flex justify-content-between align-items-center text-truncate"
                          v-for="(set, setIndex) in sets" v-bind:key="'set-' + setIndex">
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" :id="'setcheck-' + setIndex" :value="setIndex" v-model="selectedSetIndex"
                              name="customRadioInline1" class="custom-control-input">
                            <label class="custom-control-label" style="margin-top: 2px !important;" :for="'setcheck-'+setIndex">{{set.SET_NAME}} <small class="text-muted">{{set.SET_DESCRIPTION}}</small></label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 mt-1" v-if="addSetPage == 1">
                      <div class="form-group py-2 px-2">
                          <label for="exampleInputEmail1">Set Miktarı</label>
                          <input type="number" class="form-control" v-model="selectedSetQuantity" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Adet">
                          <small id="emailHelp" class="form-text text-muted">Çıkışını yapacağınız ürün set adedini girebilirsiniz. Bu şekilde çıkışını yapacağınız bütün cihaz ve sarf malzemelerinin adetlerini kolaylıkla ayarlayabilirsiniz.</small>
                        </div>
                      </div>
                  </div>
                </div>
              </v-wait>
            </div>
            <div class="modal-footer" id="footer-345">
              <button type="button" class="btn btn-secondary btn-more-radius" data-dismiss="modal">Kapat</button>
              <button type="button" v-if="addSetPage == 0" @click="addSetNext()" class="btn btn-more-radius btn-primary">Sonraki Adım &raquo;</button>
              <button type="button" v-if="addSetPage == 1" @click="addSet()" class="btn btn-more-radius btn-success">Ürün Setini Ekle</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="modalGsmValidation" tabindex="-1" role="dialog"
        aria-labelledby="modalGsmValidationLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header bg-danger">
              <h5 class="modal-title text-white" id="modalGsmValidationLabel">Kayıt tamamlanamadı</h5>
              <button type="button" class="close text-white" data-dismiss="modal" aria-label="Kapat">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p class="mb-3">Aşağıdaki SIM kart sorunlarını düzelttikten sonra kaydı tekrar tamamlayın.</p>
              <template v-if="gsmValidationIssues.duplicates.length">
                <h6 class="font-semi-bold">Birden fazla cihaza girilmiş GSM numaraları</h6>
                <ul class="list-group mb-3">
                  <li v-for="item in gsmValidationIssues.duplicates" :key="'dup-' + item.gsm"
                    class="list-group-item d-flex justify-content-between">
                    <span class="font-semi-bold">{{ item.gsm }}</span>
                    <span class="text-muted">Satır {{ item.rows.join(', ') }}</span>
                  </li>
                </ul>
              </template>
              <template v-if="gsmValidationIssues.unregistered.length">
                <h6 class="font-semi-bold">Sistemde kayıtlı olmayan SIM kartlar</h6>
                <ul class="list-group">
                  <li v-for="item in gsmValidationIssues.unregistered" :key="'unreg-' + item.row"
                    class="list-group-item d-flex justify-content-between">
                    <span class="font-semi-bold">{{ item.gsm }}</span>
                    <span class="text-muted">Satır {{ item.row }}</span>
                  </li>
                </ul>
              </template>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-more-radius" data-dismiss="modal">Kapat</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-wait>
</template>

<script>
/* eslint-disable */

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import axios from 'axios'
import { CoolSelect } from 'vue-cool-select'
import _ from 'underscore'
import GsmAutocomplete from '@/components/GsmAutocomplete'
import { normalizeGsm, hasGsmConflict, isHatOnDevice } from '@/utils/gsm'
import { toDate, formatDisplayDate } from '@/utils/date'

export default {
  name: 'ArizaKayitPage',
  components: {
    'datepicker': Datepicker,
    CoolSelect,
    GsmAutocomplete
  },
  data () {
    return {
      firstLoadInEditMode: false,
      intervalAutoSave: 0,
      copyPasted: false,
      ctrlKeydown: false,
      timeoutId: 0,
      malzemeSearching: false,
      customerSearching: false,
      procStatus: 0,
      customerSearchFilter: '',
      customerContracts: [],
      foundCustomers: [],
      retailers: [],
      sarflar: [],
      campaigns: [],
      selectedCustomer: {},
      pairedGsmByRow: {},
      gsmUsageByRow: {},
      gsmValidating: false,
      gsmValidationIssues: { duplicates: [], unregistered: [] },
      fetchedSarfMalzemeleri: [],
      selectedSarfMalzeme: {
        MALZEME_ID: 0,
        MALZEME_NAME: '',
        MALZEME_LENOI: 0,
        MALZEME_URUNMONTAJ: 0,
        MALZEME_SPENT: 0
      },
      dataRows: [
      ],
      dataRowObject: {
        ICERIK_ID: '',
        DeviceId: '',
        GsmNo: '',
        HddBrand: 'Marka',
        HddSerial: '',
        HddCapacity: '0',
        DeviceType: '0'
      },
      otherRows: [],
      urunCikisKaydi: {
        OUT_RETAILER: "0",
        OUT_DATE: "",
        OUT_CUSTOMER: "",
        OUT_WAYBILL_CODE: "",
        OUT_NOTE: "",
        OUT_CAMPAIGN: 0,
        OUT_CONTRACT: null,
      },
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      },
      sets:[],
      selectedSetIndex: -1,
      selectedSetQuantity: 1,
      addSetPage: 0,
      testModel: ''
    }
  },
  computed: {
    getSessionId: function() { return this.$store.getters.getSessionId },
    // Satir basina GSM uyarilari; sablonda ayni hesap tekrar tekrar yapilmasin
    // status: 'unregistered' (sistemde yok), 'free' (hat bosta), 'same' (bu cihaza esli),
    //         'elsewhere' (baska cihazda), null (henuz sorgulanmadi ya da sorgu basarisiz)
    gsmRowStates: function() {
      const states = {}
      this.dataRows.forEach(row => {
        const key = this.rowKey(row)
        if(this.isNonAtsDevice(row.DeviceType)) {
          states[key] = { status: null, usage: null, conflict: false }
          return
        }

        const hat = this.gsmUsageByRow[key]
        const serial = row.DeviceId ? String(row.DeviceId).trim() : ''
        let status = null
        // Sorgu sonucu yalnizca satirdaki guncel GSM'e aitse kullanilir
        if(hat && hat.gsm === normalizeGsm(row.GsmNo)) {
          if(!hat.registered)
            status = 'unregistered'
          else if(!hat.DEVICE_ID)
            status = 'free'
          else if(serial.length === 15)
            status = isHatOnDevice(hat, serial) ? 'same' : 'elsewhere'
        }

        states[key] = {
          status,
          usage: status === 'elsewhere' ? hat : null,
          conflict: hasGsmConflict(row.GsmNo, this.pairedGsmByRow[key])
        }
      })
      return states
    }
  },
  methods: {
    dateFormatter(date) {
      console.log(date);
      return moment(date).format('DD.MM.YYYY')
    },
    rowKey(row) {
      // Satir nesnesine alan eklemeden sabit anahtar; payload ve autosave degismez
      if(!this.rowKeys.has(row))
        this.rowKeys.set(row, ++this.rowKeySeq)
      return this.rowKeys.get(row)
    },
    focusRowInput(prefix, row) {
      this.$nextTick(() => {
        const refs = this.$refs[prefix + '-' + this.rowKey(row)]
        const el = Array.isArray(refs) ? refs[0] : refs
        if(el) el.focus()
      })
    },
    goToNextRow(row) {
      const index = this.dataRows.indexOf(row)
      if(index === -1) return

      if(index < this.dataRows.length - 1)
        this.focusRowInput('deviceid', this.dataRows[index + 1])
      else
        this.enterOnRow(index)
    },
    async onSerialEnter(row) {
      if(this.isNonAtsDevice(row.DeviceType)) {
        this.focusRowInput('hddserial', row)
        return
      }

      const pairedGsm = await this.lookupPairedGsm(row, true)
      if(this.dataRows.indexOf(row) === -1) return

      if(pairedGsm && normalizeGsm(row.GsmNo) === pairedGsm)
        this.goToNextRow(row)
      else
        this.focusRowInput('gsm', row)
    },
    onSerialInput(row) {
      const key = this.rowKey(row)
      const lookup = this.gsmLookups[key]
      if(lookup && lookup.serial !== row.DeviceId) {
        delete this.gsmLookups[key]
        this.$delete(this.pairedGsmByRow, key)
      }
    },
    // fresh: Tab ve Enter her seferinde API'ye sorar; blur (fareyle cikma) mevcut sonucu kullanabilir
    lookupPairedGsm(row, fresh) {
      const serial = row.DeviceId
      if(this.isNonAtsDevice(row.DeviceType) || !serial || serial.length !== 15)
        return Promise.resolve(null)

      const key = this.rowKey(row)
      return this.fetchPairedGsm(key, serial, fresh)
        .then(pairedGsm => {
          // Cevap gelene kadar seri no degistiyse sonucu kullanma
          if(row.DeviceId !== serial) return null

          // Her tetiklemede uygulanir: GSM silinip tekrar Tab'a basilirsa yeniden yazilir
          if(pairedGsm) {
            this.$set(this.pairedGsmByRow, key, pairedGsm)
            if(!normalizeGsm(row.GsmNo)) {
              row.GsmNo = pairedGsm
              this.checkGsmUsage(row)
            }
          } else {
            this.$delete(this.pairedGsmByRow, key)
          }
          return pairedGsm
        })
    },
    fetchPairedGsm(key, serial, fresh) {
      const lookup = this.gsmLookups[key]
      // Yoldaki istek paylasilir; Tab'in hemen ardindan gelen blur ikinci istek atmaz
      if(lookup && lookup.serial === serial && (lookup.pending || !fresh))
        return lookup.promise

      const entry = { serial, pending: true, promise: null }
      entry.promise = axios.get('/api/hatlar/by-device/' + encodeURIComponent(serial))
        .then(response => {
          // Esli hat yoksa backend bos dizi donebilir
          const hat = Array.isArray(response.data) ? response.data[0] : null
          return hat && hat.GSM ? normalizeGsm(hat.GSM) : null
        })
        .catch(err => {
          console.error(err)
          // Hata durumunda blur'da da tekrar denenebilsin
          if(this.gsmLookups[key] === entry)
            delete this.gsmLookups[key]
          return null
        })
        .then(pairedGsm => {
          entry.pending = false
          return pairedGsm
        })

      this.gsmLookups[key] = entry
      return entry.promise
    },
    rowState(row) {
      return this.gsmRowStates[this.rowKey(row)] || { status: null, usage: null, conflict: false }
    },
    onGsmSelect(row, item) {
      const key = this.rowKey(row)
      const gsm = normalizeGsm(item.HAT_GSMNO)
      // Listeden secilen ogede cihaz/musteri/arac bilgisi zaten var, ayrica istek atilmaz
      const result = { found: true, hat: item }
      this.gsmUsageLookups[key] = { gsm, promise: Promise.resolve(result) }
      this.applyGsmUsage(key, gsm, result)
    },
    checkGsmUsage(row) {
      const key = this.rowKey(row)
      const gsm = normalizeGsm(row.GsmNo)
      if(this.isNonAtsDevice(row.DeviceType) || gsm.length < 10) {
        this.$delete(this.gsmUsageByRow, key)
        return Promise.resolve()
      }

      return this.fetchGsmUsage(key, gsm)
        .then(result => {
          // Cevap gelene kadar GSM degistiyse sonucu kullanma
          if(normalizeGsm(row.GsmNo) === gsm)
            this.applyGsmUsage(key, gsm, result)
        })
    },
    // result: { found: true, hat } | { found: false } | null (sorgu basarisiz)
    applyGsmUsage(key, gsm, result) {
      if(!result) {
        // Hattin kayitli olup olmadigi bilinmiyor; hicbir ikon gosterilmez
        this.$delete(this.gsmUsageByRow, key)
        return
      }

      if(!result.found) {
        this.$set(this.gsmUsageByRow, key, { gsm, registered: false })
        return
      }

      // Bosta olan hatlar da saklanir; yesil tik icin hattin sistemde bulundugunu bilmek gerekiyor
      const hat = result.hat
      this.$set(this.gsmUsageByRow, key, {
        gsm,
        registered: true,
        DEVICE_ID: hat.DEVICE_ID,
        IMEI_NO: hat.IMEI_NO,
        CUSTOMER_TITLE: hat.CUSTOMER_TITLE,
        VEHICLE_NAME: hat.VEHICLE_NAME
      })
    },
    fetchGsmUsage(key, gsm) {
      const lookup = this.gsmUsageLookups[key]
      if(lookup && lookup.gsm === gsm)
        return lookup.promise

      const entry = { gsm, promise: null }
      entry.promise = axios.post('/api/hatlar/single-search', { SearchFilter: gsm })
        .then(response => {
          const hatlar = Array.isArray(response.data) ? response.data : []
          const hat = hatlar.find(h => normalizeGsm(h.HAT_GSMNO) === gsm)
          return hat ? { found: true, hat } : { found: false }
        })
        .catch(err => {
          console.error(err)
          // Hata durumunda ayni GSM icin tekrar denenebilsin
          if(this.gsmUsageLookups[key] === entry)
            delete this.gsmUsageLookups[key]
          // Istek basarisizsa hat kayitsiz sayilmaz; kirmizi unlem yanlislikla cikmasin
          return null
        })

      this.gsmUsageLookups[key] = entry
      return entry.promise
    },
    async checkAllGsmUsages() {
      // Yapistirma, duzenleme ve autosave sonrasi istekler ayni anda gitmesin
      const rows = this.dataRows.slice()
      for(let i = 0; i < rows.length; i++)
        await this.checkGsmUsage(rows[i])
    },
    usePairedGsm(row) {
      row.GsmNo = this.pairedGsmByRow[this.rowKey(row)]
      this.checkGsmUsage(row)
    },
    // Kayit oncesi GSM kontrolleri; sorun varsa modal'da listelenir ve kayit durur
    async validateGsmRows() {
      // v-wait tum formu (modal dahil) DOM'dan kaldirdigi icin kontrol sirasinda buton kilitlenir
      this.gsmValidating = true
      try {
        await this.checkAllGsmUsages()
      } finally {
        this.gsmValidating = false
      }

      const duplicates = this.findDuplicateGsms()
      const unregistered = this.findUnregisteredGsms()
      if(!duplicates.length && !unregistered.length)
        return true

      this.gsmValidationIssues = { duplicates, unregistered }
      $('#modalGsmValidation').modal('show')
      return false
    },
    findDuplicateGsms() {
      const rowsByGsm = {}
      this.dataRows.forEach((row, index) => {
        if(this.isNonAtsDevice(row.DeviceType)) return
        const gsm = normalizeGsm(row.GsmNo)
        if(!gsm) return
        if(!rowsByGsm[gsm]) rowsByGsm[gsm] = []
        rowsByGsm[gsm].push(index + 1)
      })

      return Object.keys(rowsByGsm)
        .filter(gsm => rowsByGsm[gsm].length > 1)
        .map(gsm => ({ gsm, rows: rowsByGsm[gsm] }))
    },
    findUnregisteredGsms() {
      const result = []
      this.dataRows.forEach((row, index) => {
        if(this.isNonAtsDevice(row.DeviceType)) return
        const gsm = normalizeGsm(row.GsmNo)
        if(!gsm) return
        // 10 haneden kisa numara sistemdeki hicbir hatla eslesemez, sorgulanmadan kayitsiz sayilir.
        // Sorgusu basarisiz olan GSM bilinmiyor durumundadir ve kayitsiz sayilmaz.
        if(gsm.length < 10 || this.rowState(row).status === 'unregistered')
          result.push({ row: index + 1, gsm })
      })
      return result
    },
    enterOnRow(rowIndex) {
      if(this.dataRows.length == 0) {
        this.dataRows.push({
          ICERIK_ID: '',
          DeviceId: '',
          GsmNo: '',
          HddBrand: 'Marka',
          HddSerial: '',
          HddCapacity: '0',
          DeviceType: '0'
        })
      } else {
        let lastItemIndex = this.dataRows.length - 1
        let lastDeviceType = this.dataRows[lastItemIndex].DeviceType
        let lastHddBrand = this.dataRows[lastItemIndex].HddBrand
        let lastHddCap = this.dataRows[lastItemIndex].HddCapacity
        let lastDevicePrefix = this.dataRows[lastItemIndex].DeviceId.substring(0, 8)
        let lastHddSerialPrefix = this.dataRows[lastItemIndex].HddSerial.substring(0, 2)
        this.dataRows.push({
          ICERIK_ID: '',
          DeviceId: '',
          GsmNo: '',
          HddBrand: lastHddBrand,
          HddSerial: '',
          HddCapacity: lastHddCap,
          DeviceType: lastDeviceType
        })
      }

      this.focusRowInput('deviceid', this.dataRows[this.dataRows.length - 1])
    },
    enterOnRowOther() {
      /*this.otherRows.push({
        MALZEME_ID: 0,
        MALZEME_NAME: '',
        MALZEME_LENOI: 0,
        MALZEME_URUNMONTAJ: 0,
        MALZEME_SPENT: 0
      })*/
    },
    deleteRow(index) {
      if(this.dataRows.length == 1) {
        this.dataRows = []
        //this.dataRows.push(this.rowObject)
      } else {
        this.dataRows.splice(index, 1);
      }
    },
    deleteRowOther(index) {
      this.otherRows.splice(index, 1);
    },
    deleteAllRows() {
      this.dataRows = []
      this.copyPasted = false
    },
    deleteAllOthers() {
      this.otherRows = []
      this.copyPasted = false
    },
    formatGsm2(val) {
      return normalizeGsm(val)
    },
    getUrunCikisSingle() {
      this.$wait.start('gonderi-inserting')

      axios.post("/api/uruncikis/get-single?SessionId="+ 
        this.getSessionId + "&OutId=" + this.$route.params.id)
      .then(response => {
        this.dataRows = response.data.OutDevices.length > 0 ? response.data.OutDevices : this.dataRows
        this.otherRows = response.data.OutSarflar
        this.selectedCustomer = { CUSTOMER_ID: response.data.OUT_CUSTOMER, CUSTOMER_TITLE: response.data.CUSTOMER_TITLE }
        this.customerSearchFilter = response.data.CUSTOMER_TITLE
        this.firstLoadInEditMode = true;
        this.foundCustomers.push(this.selectedCustomer)
        this.getCustomerContracts()

        this.urunCikisKaydi = response.data;
        // Backend tarihi metin olarak doner; datepicker ve kayit Date bekler
        this.$set(this.urunCikisKaydi, 'OUT_DATE', toDate(response.data.OUT_DATE) || '')
        this.checkAllGsmUsages()

        this.$wait.end('gonderi-inserting')
      })
      .catch(err => this.$wait.end('gonderi-inserting'))
    },
    async insertUrunCikis() {
      if(this.gsmValidating) return

      if(!toDate(this.urunCikisKaydi.OUT_DATE)) {
        this.$toasted.error('Uygun bir tarih seçmediniz.', this.toastOptions)
        return;
      }

      let mq = this.dataRows.filter(m => m.DeviceId.length != 15)
      if(mq != null && mq.length > 0) {
        this.$toasted.error('Ekleyecek olduğunuz cihazların seri numaraları 15 haneden oluşmalıdır.', this.toastOptions);
        return;
      }

      mq = this.dataRows.filter(m => m.DeviceType == "0" && m.DeviceId.length == 15)
      if(mq == null || (mq != null && mq.length > 0)) {
        this.$toasted.error('Cihaz türü seçilmemiş girişleri düzeltmeniz gerekiyor.', this.toastOptions)
        return;
      }

      mq = this.dataRows.filter(m => m.HddBrand != "Marka" && (m.HddSerial.trim().length == 0 || m.HddCapacity == "0"))
      if(mq == null || (mq != null && mq.length > 0)) {
        this.$toasted.error('Seri numarası ve ya kapasitesi belirlenmemiş HDD girişlerini düzeltmeniz gerekiyor', this.toastOptions)
        return;
      }

      if(!(await this.validateGsmRows()))
        return

      this.$wait.start('gonderi-inserting')
      this.dataRows.forEach(e => {
        e.DeviceType = parseInt(e.DeviceType);
      });

      this.otherRows.forEach(e => {
        e.MALZEME_ID = parseInt(e.MALZEME_ID)
        e.MALZEME_LENOI = parseInt(e.MALZEME_LENOI)
        e.MALZEME_URUNMONTAJ = parseInt(e.MALZEME_URUNMONTAJ)
        e.MALZEME_SPENT = parseInt(e.MALZEME_SPENT)
      });

      this.urunCikisKaydi.SessionId = this.getSessionId
      this.urunCikisKaydi.OUT_CUSTOMER = this.selectedCustomer.CUSTOMER_ID
      this.urunCikisKaydi.OutDevices = this.dataRows
      this.urunCikisKaydi.OutSarflar = this.otherRows
      this.urunCikisKaydi.OUT_CAMPAIGN = parseInt(this.urunCikisKaydi.OUT_CAMPAIGN);
      this.urunCikisKaydi.OUT_CONTRACT = parseInt(this.urunCikisKaydi.OUT_CONTRACT);

      // Formdaki tarih Date olarak kalir; metne sadece gonderilen kopyada cevrilir ki tekrar denemede bozulmasin
      const payload = Object.assign({}, this.urunCikisKaydi, {
        OUT_DATE: formatDisplayDate(this.urunCikisKaydi.OUT_DATE)
      })

      axios.post("/api/uruncikis/toplu-gonderi-yap", payload)
      .then(response => {
        this.$wait.end('gonderi-inserting')

        if(response.data.HasError == false) {
          localStorage.removeItem("uck-autosave")
          this.$toasted.success('Ürün çıkış kaydı eklendi', this.toastOptions)
          this.$router.push('/urun-cikislari')
        } else {
          // Basarisiz kayitta form ve musteri secimi korunur; kullanici duzeltip tekrar deneyebilir
          this.$toasted.error('Kayıt eklenemedi. Durum mesajı: ' + response.data.ErrorMessage, this.toastOptions)
        }
      })
      .catch(error => {
        console.error(error)
        // Ag ya da sunucu hatasinda bekleme ekrani kapatilmazsa sayfa kilitli kaliyor
        this.$wait.end('gonderi-inserting')
        this.$toasted.error('Kayıt eklenemedi. Sunucuya ulaşılamadı ya da beklenmeyen bir hata oluştu.', this.toastOptions)
      })
    },
    async getSarflar() {
      axios.post('/api/stok/sarflar-with-serials?sessionId='+ this.getSessionId + '&searchFilter=DEVICE')
      .then(response => {
        this.sarflar = response.data
        this.$wait.end('serials-loading')
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('serials-loading')
      })
    },
    async onSearch(search) {
      const lettersLimit = 2;
      if (search.length < lettersLimit) {
        this.fetchedSarfMalzemeleri = [];
        this.malzemeSearching = false;
        return;
      }

      this.malzemeSearching = true;

      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        await axios.post(
          '/api/stok/sarf-malzemeleri-lite?SessionId=' + this.getSessionId + "&SearchFilter=" + search
        ).then(resp => this.fetchedSarfMalzemeleri = resp.data)

        this.malzemeSearching = false;
      }, 500);
    },
    async onSelect(item) {
      if(this.otherRows.filter(m => m.MALZEME_ID == item.MALZEME_ID) != null)
      this.otherRows.push(item)
      this.selectedSarfMalzeme = {}
    },
    async onCustomerSearch(query) {
      if(!query || query.length < 4) {
        this.foundCustomers = []
        this.customerSearching = false
        return
      }

      this.customerSearching = true

      let jsonReq = {}
      jsonReq.SessionId = this.getSessionId
      jsonReq.SearchFilter = query
      jsonReq.Retailer = this.urunCikisKaydi.OUT_RETAILER
      await axios.post('/api/uruncikis/musteri-ara?sessionid=' + jsonReq.SessionId + 
        "&searchFilter=" + jsonReq.SearchFilter + "&retailer=" + jsonReq.Retailer, jsonReq)
      .then(response => {
        this.foundCustomers = response.data
        this.customerSearching = false
      })
      .catch(err => this.customerSearching = false)
      
    },
    async onCustomerSelect(item) {
      console.log('onCustomerSelect')
      console.log(item)
      console.log(this.selectedCustomer.CUSTOMER_ID + " - " + this.selectedCustomer.CUSTOMER_TITLE)

      this.getCustomerContracts()
    },
    async getCustomerContracts() {
      if(this.selectedCustomer == null || this.selectedCustomer.CUSTOMER_ID == null || this.selectedCustomer.CUSTOMER_ID.length == 0) {
        this.customerContracts = []
        console.log('getCustomerContracts - no customer selected')
        return
      }

      await axios.get('/api/uruncikis/musteri-sozlesmeleri?customerId=' + this.selectedCustomer.CUSTOMER_ID)
      .then(response => {
        this.customerContracts = response.data
      })
      .catch(err => console.log(err))
    },
    async getRetailers() {
      await axios.get('/api/a1/retailers')
      .then(response => {
        this.retailers = response.data
      })
      .catch(err => console.log(err))
    },
    onDeviceModelChange(e) {
      console.log('e.target.value ' + e.target.value)
      if(this.copyPasted && (e.target.value > 0 || e.target.value.length > 0)) {
        if(e.target.value.indexOf('Western') > -1 || e.target.value.indexOf('Seagate') > -1)
          this.dataRows.forEach((m) => m.HddBrand = e.target.value)
        else if(e.target.value.includes('TB') || e.target.value.includes('GB'))
          this.dataRows.forEach((m) => m.HddCapacity = e.target.value)
        else
          this.dataRows.forEach((m) => m.DeviceType = e.target.value)
      }
    },
    parseClipboard(text) {
      let devt = this.dataRows.length == 0 ? 0 : this.dataRows[this.dataRows.length - 1].DeviceType;
      let arr = text.split('\r\n')

      for(let i = 0; i < arr.length; i++) {
        let inArr = arr[i].split('\t')
        let deviceId = inArr.length > 0 ? inArr[0] : arr[i]
        let secVal = inArr.length > 1 ? inArr[1] : ''
        let gsmno = null;
        let hddsn = null;
        if(secVal.indexOf('05') == 0 || secVal.indexOf('5') == 0)
          gsmno = this.formatGsm2(secVal)
        else
          hddsn = secVal;
        
        if(deviceId.length == 0)
          break;

        this.dataRows.push({
          ICERIK_ID: '',
          DeviceId: deviceId,
          GsmNo: gsmno,
          HddBrand: 'Marka',
          HddSerial: hddsn,
          HddCapacity: '0',
          DeviceType: devt
        })

        this.copyPasted = true
      }

      this.checkAllGsmUsages()
    },
    isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    async getSets() {
      this.$wait.start('sets-loading')
      axios.post('/api/stok/tum-setler?sessionId=' + this.getSessionId)
      .then(response => {
        this.sets = response.data
      })
      .catch(error => { 
        console.error(error) 
      })
      this.$wait.end('sets-loading')
    },
    addSetNext() {
      this.addSetPage = 1
    },
    async addSet() {
      let setob = this.sets[this.selectedSetIndex]
      let icerik = this.parseSetIcerik(setob.SET_ICERIK)
      let devOps = icerik.find(m => m.MALZEME_CODE.indexOf('DEVICE') > -1)
      if(devOps) {
        for(let i = 0; i < this.selectedSetQuantity; i++) {
          this.dataRows.push({
            ICERIK_ID: '',
            DeviceId: '',
            GsmNo: '',
            HddBrand: 'Marka',
            HddSerial: '',
            HddCapacity: '0',
            DeviceType: devOps.MALZEME_ID
          })
        }
      }

      for(let k = 0; k < icerik.length; k++) {
        if(icerik[k].MALZEME_CODE.indexOf('DEVICE') > -1) continue;
        this.otherRows.push({'MALZEME_ID': icerik[k].MALZEME_ID, 'MALZEME_NAME': icerik[k].MALZEME_NAME, 'MALZEME_SPENT': (icerik[k].MALZEME_QUANTITY * this.selectedSetQuantity), 
          'MALZEME_LENOI': 0, 'MALZEME_URUNMONTAJ': 0});
      }

      setob = null
      devOps = null
      icerik = null

      this.selectedSetIndex = -1
      this.addSetPage = 0
      this.selectedSetQuantity = 1
      $("#modalSetList").modal('hide')
    },
    parseSetIcerik(icerik) {
      let arr = icerik.split(',');
      let data = []
      for(let i = 0; i < arr.length; i++) {
        let obs = arr[i].split('-');
        let ob1, ob2, ob3, ob4;
        ob1 = obs[0];
        ob2 = obs[1];
        ob3 = obs[2];
        ob4 = obs[3];
        data.push({'MALZEME_CODE': ob1, 'MALZEME_NAME': ob2, 'MALZEME_QUANTITY': ob3, 'MALZEME_ID': ob4});
      }
      return data;
    },
    autoSaveUrunCikis() {
      let uckAutoSave = {}
      uckAutoSave.SessionId = this.getSessionId
      uckAutoSave.OUT_DATE = formatDisplayDate(this.urunCikisKaydi.OUT_DATE)
      uckAutoSave.OUT_CUSTOMER = this.selectedCustomer.CUSTOMER_ID
      uckAutoSave.OutDevices = this.dataRows
      uckAutoSave.OutSarflar = this.otherRows
      uckAutoSave.CustomerData = this.selectedCustomer

      localStorage.setItem("uck-autosave", JSON.stringify(uckAutoSave))
    },
    getRecoveredUck() {
      console.log("------ checking uck-autosave data ------")
      let recoveredData = JSON.parse(localStorage.getItem("uck-autosave"))
      if(!recoveredData)
        return
      else
        console.log(recoveredData)

      this.urunCikisKaydi = recoveredData
      this.urunCikisKaydi.OUT_RETAILER = recoveredData.OUT_RETAILER
      // Autosave tarihi "DD.MM.YYYY" metni olarak saklar; datepicker ve kayit Date bekler
      this.$set(this.urunCikisKaydi, 'OUT_DATE', toDate(recoveredData.OUT_DATE) || '')

      if(recoveredData.OutDevices && recoveredData.OutDevices.length > 0) {
        this.dataRows = recoveredData.OutDevices
        this.checkAllGsmUsages()
      }

      if(recoveredData.OutSarflar && recoveredData.OutSarflar.length > 0)
        this.otherRows = recoveredData.OutSarflar

      if(recoveredData.CustomerData) {
        this.selectedCustomer = recoveredData.CustomerData
        this.customerSearchFilter = recoveredData.CustomerData.CUSTOMER_TITLE
      }
    },
    async getCampaigns() {
      axios.post('/api/uruncikis/campaigns?sessionId=' + this.getSessionId)
      .then(response => {
        this.campaigns = response.data
      })
      .catch(error => { 
        console.error(error) 
      })
    },
    highlight(content, search) {
      if(!content) {
          return content;
      }
      return content.replace(new RegExp(search, "gi"), match => {
          return '<span class="highlightText">' + match + '</span>';
      });
    },
    isNonAtsDevice(deviceId) {
      console.log(deviceId)
      return (deviceId == 300 || deviceId == 301 || deviceId == 302 || deviceId == 316)
    }
  },
  created() {
    // Render'dan once hazir olmali; reaktif olmalarina gerek yok
    this.rowKeys = new WeakMap()
    this.rowKeySeq = 0
    this.gsmLookups = {}
    this.gsmUsageLookups = {}

    moment.locale('tr')
    let obt = this
    
    this.getRetailers()
    this.getSarflar()
    this.getSets()
    this.getCampaigns()

    if(this.$route.params.id === undefined)
      this.getRecoveredUck()
    else
      this.getUrunCikisSingle()

    document.addEventListener('paste', event => {
      event.preventDefault();
      navigator.clipboard.readText().then(text => {
        obt.parseClipboard(text)
      });
    });

    this.intervalAutoSave = setInterval(() => this.autoSaveUrunCikis(), 30000)
  },
  beforeDestroy() {
    document.removeEventListener('paste', event => {});
    clearInterval(this.intervalAutoSave)
    this.intervalAutoSave = 0
  }
}
</script>

<style scoped>

  div:has(div.search-slot-item) {
    padding: 0px !important;
  }

  div:has(div.search-slot-item):hover {
    background-color: transparent !important;
  }

  .search-slot-item {
    padding: 0px 0px !important;
    width: 100%;
  }

  .search-slot-item:hover p, .search-slot-item:hover small { }

  .search-slot-item p {
    margin-bottom: -5px;
    font-size: .875rem;
    font-weight: 500;
  }

  .search-slot-item p .highlightText  {
    background-color: yellow !important;
    font-weight: 700 !important;
    display: inline-block;
  }
  
  .form-control-cstm {
    width: 43.4%;
  }

  .container {
    max-width: 1280px;
  }

  .transparent-label { color: rgba(0,0,0,0);}
  .light-text { 
    font-weight: 400 !important; 
    -webkit-user-select: none; /* Safari */        
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */
  }
  .lh-condensed { line-height: 1.25; } 

  /* The switch - the box around the slider */
.switch {
  position: absolute;
  display: inline-block;
  z-index: 1;
  right: 10px;
  top: 10px;
  width: 40px;
  height: 25px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #1DB954;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #F00;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 26px;
}

.slider.round:before {
  border-radius: 50%;
}

input[type="text"].loading {
  background-image: url("~/static/loading.svg");
  background-size: 32px 32px;
  background-position:right center;
  background-repeat: no-repeat;
}

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .font-semi-bold {
    font-weight: 600;
  }

  /* GSM uyarilarinin detaylari satirin altinda, GSM sutununa hizali */
  .gsm-notes {
    margin-top: .25rem;
    padding-right: 2.75rem;
    text-align: right;
    font-size: .8125rem;
    line-height: 1.4;
    color: #6c757d;
  }

</style>


// WEBPACK FOOTER //
// src/components/GonderiYapPage.vue